import type { PropsWithChildren } from 'react'
import { useToken } from '@sunwebgroup/ui-components'
import * as React from 'react'

import { useMedia } from 'react-use'

const BreakpointContext = React.createContext({
  isDesktopSm: false,
  isDesktopMd: false,
  isDesktopLg: false,
  isDesktopXl: false,
  isTablet: false,
  isMobile: false,
})
export function BreakpointProvider({ children }: PropsWithChildren) {
  const mqDesktopSm = useToken<string>('mq_desktop_sm')
  const mqDesktopMd = useToken<string>('mq_desktop_md')
  const mqDesktopLg = useToken<string>('mq_desktop_lg')
  const mqDesktopXl = useToken<string>('mq_desktop_xl')
  const mqTablet = useToken<string>('mq_tablet')
  const mqMobile = useToken<string>('mq_mobile')

  const isMobile = useMedia(mqMobile, false)
  const isTablet = useMedia(mqTablet, false)
  const isDesktopSm = useMedia(mqDesktopSm, false)
  const isDesktopMd = useMedia(mqDesktopMd, false)
  const isDesktopLg = useMedia(mqDesktopLg, false)
  const isDesktopXl = useMedia(mqDesktopXl, false)

  const value = React.useMemo(
    () => ({ isMobile, isTablet, isDesktopSm, isDesktopMd, isDesktopLg, isDesktopXl }),
    [isMobile, isTablet, isDesktopSm, isDesktopMd, isDesktopLg, isDesktopXl],
  )

  return <BreakpointContext value={value}>{children}</BreakpointContext>
}

// @deprecated This hook is working with pre-UDS breakpoints. For new designs using UDS use useBreakpoints instead
export const useBreakpoints = () => React.use(BreakpointContext)
